import { get,post } from "../../services/HttpService";


export class BsesApiService {
    static validations = {};

    static getCustomerDetails = (queryData = {}, config = {}) => {
        return post(`bses/api/v1/get/customer_details/`, queryData, config).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };

    static payBill = (queryData = {}, config = {}) => {
        return post(`bses/api/v1/pay/bill/`, queryData, config).catch((error) => ({
            success: false,
            data: error?.response?.data ?? {},
            status: error?.response?.status ?? 400,
        }));
    };
}